import CustomChip from "../../../@core/components/mui/chip";
import { CustomChipProps } from "../../../@core/components/mui/chip/types";
import { hexToRGBA } from "../../../@core/utils/hex-to-rgba";
import { SupplierOrderOption } from "../types/dto";
import { SupplierOrderFields } from "../types/fields";
import { getSupplierOrderStatusColor } from "../types/typification";

interface SupplierOrderStatusChipProps extends CustomChipProps {
    SupplierOrderOption: SupplierOrderOption,
    elevation?: number
}

function SupplierOrderStatusChip({ SupplierOrderOption, elevation, ...rest }: SupplierOrderStatusChipProps) {
    const color = getSupplierOrderStatusColor(SupplierOrderOption[SupplierOrderFields.StatusCode]);

    return (
        <CustomChip
            label={SupplierOrderOption[SupplierOrderFields.StatusDesc]}
            skin='light'
            sx={{
                p: 1,
                color: color,
                backgroundColor: hexToRGBA(color, 0.18),
                boxShadow: elevation,
                ...rest.sx
            }}
            size='small'
            {...rest}
        />
    );
}

export default SupplierOrderStatusChip;